










































import {Vue, Component, Prop, Mixins} from 'vue-property-decorator';
import HeroShape from './HeroShape.vue';
import HeroFullContent from './HeroFullContent.vue';
import HeroButton from './HeroButton.vue';
import HeroSecondaryContent from './HeroSecondaryContent.vue';
import scrollToMixin from '@/mixins/scrollToMixin';

const smallDeviceCheck = (mq: any, vm: any) => vm.isSmallDevice = mq.matches

@Component({
    name: 'WebinarHero',
    mixins: [scrollToMixin],
    components: {
        HeroShape, HeroFullContent,
        HeroButton, HeroSecondaryContent
    },
})
export default class WebinarHero extends scrollToMixin {
    isOpen = false;

    isSmallDevice = false;

    PUBLIC_PATH = process.env.VUE_APP_ASSETS_PATH;

    created() {
        const mql = window.matchMedia('(max-width: 767.98px)');

        mql.addListener((mq) => smallDeviceCheck(mq, this))
        smallDeviceCheck(mql, this)
    }

    readmeClicked() {
        // this.$emit('readMore');
        // this.isOpen = !this.isOpen
    }

    get fullContentStyleMobile() {
        return {
            'max-height': this.isOpen ? '1000px' : '0px',
            'height': 'auto',
            'overflow': 'hidden'
        }
    }
}
